module.exports = __webpack_public_path__ + "img/1.509ab1bb.svg";